import {Component, OnInit, Input, OnDestroy} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {TaskEditDialogComponent} from './task-edit-dialog/task-edit-dialog.component';
import {TasksService} from '../../../../data/tasks/tasks.service';
import {Task} from '../../../../data/tasks/task';
import {WsService} from 'projects/app-misc/src/app/modules/data/ws.service';
import {filter, debounceTime, bufferTime} from 'rxjs/operators';
import {WsUpdateResponce} from 'projects/app-misc/src/app/modules/data/ws-update-responce';
import {User} from 'projects/core/src/lib/login/data/user';
import {UserService} from 'projects/core/src/lib/login/data/user.service';
import {AppStateQuery} from 'projects/desktop/src/app/data/app-state.query';
import {DeviceDetectorService} from 'ngx-device-detector';
import {ShortTask} from '../../../../data/tasks/short-task';
import {takeUntil} from 'rxjs/operators';
import {RxJSUnsubscribe} from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import {RxJSUnsubscribable} from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import {Subject, Subscription} from 'rxjs';
import {LocalStorage} from 'ngx-webstorage';


@Component({
    selector: 'app-task-column',
    templateUrl: './task-column.component.html',
    styleUrls: ['./task-column.component.scss'],
    providers: [DeviceDetectorService]
})
@RxJSUnsubscribe
export class TaskColumnComponent implements OnInit, OnDestroy, RxJSUnsubscribable {

    @Input()
    tasksForMe: boolean;

    tasksLoading: boolean;

    tasks: ShortTask[];

    users: User[];

    @LocalStorage('taskColumn.firstUserId')
    firstUserId: number;

    @LocalStorage('taskColumn.secondUserId')
    secondUserId: number;

    @LocalStorage('taskColumn.myTasks.sortMode')
    myTasksSortMode: string;

    @LocalStorage('taskColumn.myTasks.sortOrder')
    myTasksSortOrder: string;

    @LocalStorage('taskColumn.otherTasks.sortMode')
    otherTasksSortMode: string;

    @LocalStorage('taskColumn.otherTasks.sortOrder')
    otherTasksSortOrder: string;

    sortMode: string;
    sortOrder: string;

    firstUser: User = null;
    secondUser: User = null;
    usersLoading: boolean;

    currentUser: User;

    isMobile = false;
    isTablet = false;

    wsSub: Subscription;

    sortModes = [
        { label: 'Default', value: 'default', icon: 'pi pi-list' },
        { label: 'Due Date', value: 'deadline', icon: 'pi pi-calendar' },
        { label: 'Updated Date', value: 'lastUpdatedDate', icon: 'pi pi-clock' },
        { label: 'Created Date', value: 'created', icon: 'pi pi-calendar-plus' },
        { label: 'Updated + Created Date', value: 'lastUpdatedDate,created', icon: 'pi pi-calendar-plus' }
    ];

    constructor(
        protected dialog: MatDialog,
        protected wsService: WsService,
        protected userService: UserService,
        protected appStateQuery: AppStateQuery,
        protected deviceDetectorService: DeviceDetectorService,
        private tasksService: TasksService
    ) {
    }

    ngOnInit() {
        if (this.tasksForMe) {
            this.sortMode = this.myTasksSortMode || 'default';
            this.sortOrder = this.myTasksSortOrder || 'ASC';
        } else {
            this.sortMode = this.otherTasksSortMode || 'default';
            this.sortOrder = this.otherTasksSortOrder || 'ASC';
        }

        this.tasksLoading = true;
        this.getCurrentUser();

        if (!this.tasksForMe) {
            this.getUsers();
        }
        this.getTasks();
        this.subToSocket('task');


        this.isMobile = this.deviceDetectorService.isMobile();
        this.isTablet = this.deviceDetectorService.isTablet();
    }

    getTasks() {
        if (this.tasksForMe) {
            this.getTasksForMe();
        } else {
            this.getFilteredTasks();
        }
    }

    subToSocket(clazz: string) {
        this.wsSub = this.wsService.listenUntilDestroyed<WsUpdateResponce<Task>>('/topic/update/model.task.' + clazz, this)
            .pipe(
                debounceTime(100)
            )
            .subscribe(updateInfo => {
                if (updateInfo.action === 'CREATE') {
                    const ftask = this.tasks.find(task => task.id === updateInfo.entity.id)
                    if (typeof ftask === 'undefined') {
                        this.getShortTask(updateInfo.entity.id);
                    }
                }

                if (updateInfo.action === 'UPDATE') {
                    this.updateTask(updateInfo.entity.id);
                }

                if (updateInfo.action === 'DELETE') {
                    const index = this.tasks.findIndex(task => task.id === updateInfo.entity.id);

                    if (index > -1) {
                        this.tasks.splice(index, 1);
                    }
                }
            })
    }

    getShortTask(taskId: number) {

        const fTaskIndex = this.tasks.findIndex(t => t.id === taskId)

        this.tasksService.getShortTask(taskId).subscribe(shTask => {
            shTask.collapsed = shTask.collapsed !== false;

            if (fTaskIndex >= 0) {
                this.tasks[fTaskIndex] = shTask
            } else {
                if (shTask.assignedUserName === this.currentUser.name && this.tasksForMe) {
                    this.tasks.unshift(shTask);
                } else if (shTask.authorName === this.currentUser.name && !this.tasksForMe) {
                    this.tasks.unshift(shTask);
                }
            }

        })
    }

    updateTask(taskId: number) {
        const fTaskIndex = this.tasks.findIndex(t => t.id === taskId)

        if (fTaskIndex >= 0) {
            const currentCollapsed = this.tasks[fTaskIndex].collapsed;
            this.tasksService.getShortTask(taskId).subscribe(shTask => {
                shTask.collapsed = currentCollapsed;
                this.tasks[fTaskIndex] = shTask
            })
        }
    }

    getTasksForMe() {
        let sortByFieldName1: string;
        let sortByFieldName2: string;
        let sortOrderParam: string;

        if (this.sortMode !== 'default') {
            if (this.sortMode === 'lastUpdatedDate,created') {
                sortByFieldName1 = 'lastUpdatedDate';
                sortByFieldName2 = 'created';
            } else {
                sortByFieldName1 = this.sortMode;
            }
            sortOrderParam = this.sortOrder;
        }

        this.tasksService.getTasksForMe(sortByFieldName1, sortOrderParam, sortByFieldName2).subscribe(tasks => {
            this.tasks = tasks.map(task => ({...task, collapsed: task.collapsed !== false}));
            this.tasksLoading = false;
        })
    }

    getTasksByMe() {
        this.tasksService.getTasksByMe().subscribe(tasks => {
            this.tasks = tasks.map(task => ({...task, collapsed: task.collapsed !== false}));
            this.tasksLoading = false;
        })
    }

    getFilteredTasks() {
        let sortByFieldName1: string;
        let sortByFieldName2: string;
        let sortOrderParam: string;

        if (this.sortMode !== 'default') {
            if (this.sortMode === 'lastUpdatedDate,created') {
                sortByFieldName1 = 'lastUpdatedDate';
                sortByFieldName2 = 'created';
            } else {
                sortByFieldName1 = this.sortMode;
            }
            sortOrderParam = this.sortOrder;
        }

        this.tasksService.getFilteredTasks(this.firstUserId, this.secondUserId, sortByFieldName1, sortOrderParam, sortByFieldName2).subscribe(tasks => {
            this.tasks = tasks.map(task => ({...task, collapsed: task.collapsed !== false}));
            this.tasksLoading = false;
        })
    }

    onFirstUserChange() {
        this.firstUserId = this.firstUser ? this.firstUser.id : null;
        this.getFilteredTasks();
    }

    onSecondUserChange() {
        this.secondUserId = this.secondUser ? this.secondUser.id : null;
        this.getFilteredTasks();
    }

    cycleSortMode() {
        const currentIndex = this.sortModes.findIndex(mode => mode.value === this.sortMode);
        const nextIndex = (currentIndex + 1) % this.sortModes.length;
        this.sortMode = this.sortModes[nextIndex].value;

        if (this.tasksForMe) {
            this.myTasksSortMode = this.sortMode;
        } else {
            this.otherTasksSortMode = this.sortMode;
        }

        this.getTasks();
    }

    toggleSortOrder() {
        this.sortOrder = this.sortOrder === 'ASC' ? 'DESC' : 'ASC';

        if (this.tasksForMe) {
            this.myTasksSortOrder = this.sortOrder;
        } else {
            this.otherTasksSortOrder = this.sortOrder;
        }

        this.getTasks();
    }

    getCurrentSortMode() {
        return this.sortModes.find(mode => mode.value === this.sortMode);
    }


    createNewTask() {

        const dialogRef = this.dialog.open(TaskEditDialogComponent, {
            data: {
                task: null,
                buttonLabel: 'Create',
                tasksForMe: this.tasksForMe
            },
            panelClass: 'task-edit-dialog',
            disableClose: false
        });

        dialogRef.afterClosed().subscribe(result => {
            if (typeof result !== 'undefined') {
                if (result !== 'close-button') {
                    const task = result as Task;

                    const tempResult = Object.assign({}, task) as ShortTask
                    tempResult.assignedUserName = task.assignedUser.name;
                    tempResult.authorName = task.author.name;
                    tempResult.projectId = task.project ? task.project.id : null;
                    tempResult.projectName = task.project ? task.project.name : null;

                    const ftaskindex = this.tasks.findIndex(fftask => fftask.id === task.id)
                    ftaskindex >= 0 ? this.tasks[ftaskindex] = tempResult : this.tasks.unshift(tempResult)
                }
            }
        });
    }

    toggleTaskCollapse(task: ShortTask) {
        task.collapsed = !task.collapsed;
    }

    editTask(task: ShortTask) {
        const dialogRef = this.dialog.open(TaskEditDialogComponent, {
            data: {
                task,
                projectId: task.projectId,
                projectName: task.projectName,
                buttonLabel: 'Save'
            },
            panelClass: 'task-edit-dialog',
            disableClose: false
        });

        dialogRef.afterClosed().subscribe(result => {
            if (typeof result !== 'undefined') {
                if (result === 'DELETE') {
                    const index = this.tasks.indexOf(task, 0);
                    if (index > -1) {
                        this.tasks.splice(index, 1);
                    }
                } else {
                    const tempTask = result as Task;
                    const ftask = this.tasks.find(ttask => ttask.id === result.id);

                    if (ftask) {
                        ftask.text = tempTask.text;
                        ftask.assignedUserName = tempTask.assignedUser.name;
                        ftask.projectId = tempTask.project ? tempTask.project.id : null;
                        ftask.projectName = tempTask.project ? tempTask.project.name : null;
                        ftask.deadline = tempTask.deadline;
                    }
                }
            }
        });
    }

    getUsers() {
        this.usersLoading = true;
        this.userService.getActiveUsers().pipe(takeUntil(this.getUnsubFromAllSubs())).subscribe(users => {
            this.users = users;

            console.log('firstUser', this.firstUser);
            console.log('currentUser', this.currentUser);
            if (this.firstUserId) {
                console.log('storedFirstId', this.firstUserId);
                const found = this.users.find(user => user.id === this.firstUserId);
                console.log('found', found);
                if (found) {
                    this.firstUser = found;
                } else {
                    if (this.currentUser) {
                        this.firstUser = this.users.find(user => user.id === this.currentUser.id) || null;
                        this.firstUserId = this.firstUser ? this.firstUser.id : null;
                    } else {
                        this.firstUser = null;
                        this.firstUserId = null;
                    }
                }
            }

            if (this.secondUserId) {
                const found2 = this.users.find(user => user.id === this.secondUserId);
                this.secondUser = found2 || null;
                if (!found2) {
                    this.secondUserId = null;
                }
            }

            this.usersLoading = false;
        })
    }

    getCurrentUser() {
        this.appStateQuery.currentUser$.subscribe(user => this.currentUser = user)
    }

    ngOnDestroy() {
        if (this.wsSub) {
            this.wsSub.unsubscribe()
            this.wsSub = null;
        }
    }

    getUnsubFromAllSubs(): Subject<boolean> {
        return null
    }
}
